import React, { useState } from "react";
import { DayOfWeek } from "../../../../../Pages/Shifts/utils";

import "./DaySelector.scss";
const weekButtons = [
  { label: "Mo", value: 1, key: DayOfWeek.MONDAY },
  { label: "Tu", value: 2, key: DayOfWeek.TUESDAY },
  { label: "We", value: 3, key: DayOfWeek.WEDNESDAY },
  { label: "Th", value: 4, key: DayOfWeek.THURSDAY },
  { label: "Fr", value: 5, key: DayOfWeek.FRIDAY },
  { label: "Sa", value: 6, key: DayOfWeek.SATURDAY },
  { label: "Su", value: 0, key: DayOfWeek.SUNDAY },
];

type Props = {
  excludedWeekDays: any;
  setExcludedWeekDays: (value: any) => void;
};
const DaySelector: React.FC<Props> = ({
  excludedWeekDays,
  setExcludedWeekDays,
}) => {
  //   const [excludedDays, setExcludedDays] = useState<number[]>([]);

  const toggleDay = (value: number) => {
    setExcludedWeekDays(
      (prev: any) =>
        prev.includes(value)
          ? prev.filter((v: any) => v !== value) // klikom ga ponovo uključujemo (uklanjamo iz isključenih)
          : [...prev, value] // klikom ga isključujemo (dodajemo u listu isključenih)
    );
  };

  console.log("excludedDays", excludedWeekDays);
  const isDaySelected = (value: number) => !excludedWeekDays.includes(value);
  return (
    <div className="weekDays">
      {weekButtons.map((day) => (
        <div
          key={day.key}
          onClick={() => toggleDay(day.value)}
          className="weekDay"
          style={{
            backgroundColor: isDaySelected(day.value) ? "#3399CC" : "#EAF8F9",
            color: isDaySelected(day.value) ? "white" : "#3399CC",
          }}
        >
          {day.label}
        </div>
      ))}
    </div>
  );
};

export default DaySelector;
